export const headers = {
  item_code: {
    name: "itemCode",
    width: 0.18,
    textAlign: "left",
  },
  bp_name: {
    name: "customer",
    width: 0.55,
    textAlign: "left",
  },
  container_number: {
    name: "containerNo",
    width: 0.25,
    textAlign: "left",
  },
  state: {
    name: "state",
    width: 0.18,
    textAlign: "left",
  },
  description: {
    name: "description",
    width: 0.7,
    textAlign: "left",
  },
  packing_list_no: {
    name: "packingNo",
    width: 0.18,
    textAlign: "left",
  },
  quantity: {
    name: "quantity",
    width: 0.18,
    textAlign: "left",
  },
  etd_date: {
    name: "etd",
    width: 0.25,
    textAlign: "left",
  },
  eta_date: {
    name: "eta",
    width: 0.25,
    textAlign: "left",
    isSort: true,
    sortDirection: "asc",
  },
  // u_coo: {
  //   name: "U COO#",
  //   width: 0.2,
  //   textAlign: "left",
  // },
  // sales_name: {
  //   name: "Sales",
  //   width: 0.25,
  //   textAlign: "left",
  // },
  ship_status: {
    name: "status",
    width: 0.2,
    textAlign: "left",
  },
  "": { name: "", width: 0.2, textAlign: "" },
};

export const mdHeaders = {
  item_code: {
    name: "itemCode",
    width: 0.2,
    textAlign: "left",
  },
  bp_name: {
    name: "customer",
    width: 0.5,
    textAlign: "left",
  },
  container_number: {
    name: "containerNo",
    width: 0.3,
    textAlign: "left",
  },
  quantity: {
    name: "quantity",
    width: 0.15,
    textAlign: "left",
  },
  packing_list_no: {
    name: "packingNo",
    width: 0.15,
    textAlign: "left",
  },
  etd_date: {
    name: "etd",
    width: 0.25,
    textAlign: "left",
  },
  eta_date: {
    name: "eta",
    width: 0.25,
    textAlign: "left",
    isSort: true,
    sortDirection: "asc",
  },
  ship_status: {
    name: "status",
    width: 0.25,
    textAlign: "left",
  },
  "": { name: "", width: 0.3, textAlign: "" },
};

export const smHeaders = {
  item_name: {
    name: "itemName",
    width: 0.26,
    textAlign: "left",
  },
  quantity: {
    name: "quantity",
    width: 0.25,
    textAlign: "left",
  },
  eta_date: {
    name: "eta",
    width: 0.35,
    textAlign: "left",
    isSort: true,
    sortDirection: "asc",
  },
  ship_status: {
    name: "status",
    width: 0.28,
    textAlign: "left",
  },
  "": { name: "", width: 0.085, textAlign: "" },
};

/**
 * --------- NESTED HEADERS ---------
 * */

export const nestedHeaders = {
  item_code: {
    name: "itemCode",
    width: 0.18,
    textAlign: "left",
    isSort: false,
    sortDirection: "asc",
  },
  bp_name: {
    name: "customer",
    width: 0.55,
    textAlign: "left",
  },
  container_number: {
    name: "containerNo",
    width: 0.25,
    textAlign: "left",
  },
  state: {
    name: "state",
    width: 0.18,
    textAlign: "left",
  },
  description: {
    name: "description",
    width: 0.7,
    textAlign: "left",
  },
  packing_list_no: {
    name: "packingNo",
    width: 0.18,
    textAlign: "left",
  },
  quantity: {
    name: "quantity",
    width: 0.18,
    textAlign: "left",
  },
  // etd_date: {
  //   name: "etd",
  //   width: 0.25,
  //   textAlign: "left",
  // },
  // eta_date: {
  //   name: "eta",
  //   width: 0.25,
  //   textAlign: "left",
  // },
  // u_coo: {
  //   name: "U COO#",
  //   width: 0.2,
  //   textAlign: "left",
  // },
  // sales_name: {
  //   name: "Sales",
  //   width: 0.25,
  //   textAlign: "left",
  // },
  ship_status: {
    name: "status",
    width: 0.2,
    textAlign: "left",
  },
  "": { name: "", width: 0.2, textAlign: "" },
};

export const mdNestedHeaders = {
  item_code: {
    name: "itemCode",
    width: 0.2,
    textAlign: "left",
    isSort: true,
    sortDirection: "asc",
  },
  bp_name: {
    name: "customer",
    width: 0.5,
    textAlign: "left",
  },
  container_number: {
    name: "containerNo",
    width: 0.3,
    textAlign: "left",
  },
  quantity: {
    name: "quantity",
    width: 0.15,
    textAlign: "left",
  },
  packing_list_no: {
    name: "packingNo",
    width: 0.15,
    textAlign: "left",
  },
  // etd_date: {
  //   name: "etd",
  //   width: 0.25,
  //   textAlign: "left",
  // },
  // eta_date: {
  //   name: "eta",
  //   width: 0.25,
  //   textAlign: "left",
  // },
  ship_status: {
    name: "status",
    width: 0.25,
    textAlign: "left",
  },
  "": { name: "", width: 0.3, textAlign: "" },
};

export const smNestedHeaders = {
  item_name: {
    name: "itemName",
    width: 1,
    textAlign: "left",
    isSort: true,
    sortDirection: "asc",
  },
  quantity: {
    name: "quantity",
    width: 0.5,
    textAlign: "left",
  },
  ship_status: {
    name: "status",
    width: 0.3,
    textAlign: "right",
  },
  "": { name: "", width: 0.1, textAlign: "" },
};
